import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import objectAssign from 'object-assign'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import devices from './modules/deviceModules/deviceModule.js'
import places from './modules/placeModules/placeModule.js'
import belongs from './modules/belongModules/belongModule.js'
import assessmentInfos from './modules/assessmentInfoModules/assessmentInfoModule.js'
import careworkers from './modules/careworkerModules/careworkerModule.js'
import adminAccounts from './modules/adminAccountModules/adminAccountModule.js'
import auditLoggings from './modules/auditLoggingModules/auditLoggingModule.js'
import beacons from './modules/beaconModules/beaconModule.js'
import masters from './modules/masterModules/masterModule.js'
import error from './modules/errorModules/errorModule.js'
import dashboard from './modules/dashboardModules/dashBoardModule.js'
import loginUsers from './modules/loginUserModules/loginUserModule.js'
import notificationsTenant from './modules/notificationsModules/notificationsModule.js'
import assigns from './modules/assignModules/assignModule.js'
import reserve from './modules/reserveModules/reserveModule.js'
import template from './modules/templateModules/templateModule.js'
import messageHistory from './modules/messageHistoryModules/messageHistoryModule.js'
import userNotification from './modules/userNotificationModules/userNotificationModule.js'

// masterPanel用import
import masterSessions from './systemAdminModules/sessionModules/sessionModule.js'
import systemAdminDefine from './systemAdminModules/systemAdminDefineModules/systemAdminDefineModule.js'
import corporations from './systemAdminModules/companiesModules/companiesModule.js'
import corporationsCommonOption from './systemAdminModules/companiesCommonOptionModules/companiesCommonOptionModule.js'
import notifications from './systemAdminModules/notificationsModules/notificationsModule.js'
import maintenance from './systemAdminModules/maintenanceModules/maintenanceModule.js'
import forcedUpdate from './systemAdminModules/forcedUpdateModules/forcedUpdateModule.js'
import mailHistory from './systemAdminModules/mailHistoryModules/mailHistoryModule.js'

Vue.use(Vuex)
Vue.use(objectAssign)
Vue.use(flatPickr)

export default new Vuex.Store({
  modules: {
    devices,
    places,
    belongs,
    assessmentInfos,
    careworkers,
    adminAccounts,
    auditLoggings,
    beacons,
    masters,
    error,
    dashboard,
    loginUsers,
    notifications,
    maintenance,
    forcedUpdate,
    masterSessions,
    systemAdminDefine,
    corporations,
    corporationsCommonOption,
    notificationsTenant,
    assigns,
    mailHistory,
    reserve,
    template,
    messageHistory,
    userNotification
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js